export const styles = {
  container: {
    maxWidth: "850px",
    margin: "0 auto",
    padding: "24px",
    backgroundColor: "#f8f9fa",
    borderRadius: "16px",
    boxShadow: "0 5px 30px rgba(0,0,0,0.1)",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
  },
  logoContainer: {
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    backgroundColor: "#4a6cf7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "14px",
    boxShadow: "0 2px 8px rgba(74,108,247,0.25)",
  },
  logo: {
    color: "white",
    fontSize: "20px",
    fontWeight: "bold" as const,
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column" as const,
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: "#212529",
    margin: "0",
  },
  subtitle: {
    fontSize: "0.9rem",
    color: "#6c757d",
    marginTop: "4px",
  },
  agentSelector: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#e9ecef",
    borderRadius: "24px",
    padding: "4px",
  },
  agentButton: {
    padding: "8px 16px",
    borderRadius: "20px",
    fontSize: "0.9rem",
    fontWeight: "500",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "transparent",
    color: "#495057",
  },
  agentButtonActive: {
    backgroundColor: "white",
    color: "#4a6cf7",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  agentIcon: {
    marginRight: "6px",
    fontSize: "14px",
  },
  chatContainer: {
    marginTop: "20px",
    border: "1px solid #e9ecef",
    borderRadius: "12px",
    backgroundColor: "white",
    height: "380px",
    overflowY: "auto" as const,
    padding: "20px",
    display: "flex",
    flexDirection: "column" as const,
    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.03)",
  },
  messageContainer: {
    display: "flex",
    marginBottom: "20px",
    transition: "opacity 0.3s ease",
  },
  userMessageContainer: {
    justifyContent: "flex-end" as const,
  },
  aiMessageContainer: {
    justifyContent: "flex-start" as const,
  },
  avatar: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "bold" as const,
    color: "white",
  },
  userAvatar: {
    backgroundColor: "#6c757d",
    marginLeft: "12px",
  },
  aiAvatar: {
    backgroundColor: "#4a6cf7",
    marginRight: "12px",
  },
  message: {
    maxWidth: "70%",
    padding: "14px 18px",
    borderRadius: "18px",
    fontSize: "0.95rem",
    lineHeight: "1.6",
    whiteSpace: "pre-wrap" as const,
  },
  userMessage: {
    backgroundColor: "#e9ecef",
    color: "#212529",
    borderTopRightRadius: "4px",
  },
  aiMessage: {
    backgroundColor: "#f1f5ff",
    color: "#212529",
    borderTopLeftRadius: "4px",
    textAlign: "left" as const,
  },
  codeBlock: {
    backgroundColor: "#282c34",
    color: "#abb2bf",
    borderRadius: "6px",
    padding: "12px",
    overflowX: "auto" as const,
    fontSize: "0.9rem",
    fontFamily: 'Menlo, Monaco, "Courier New", monospace',
    marginTop: "8px",
    marginBottom: "8px",
  },
  highlightSection: {
    backgroundColor: "rgba(255, 170, 50, 0.2)",
    borderLeft: "3px solid #ffaa32",
    padding: "1px 0 1px 8px",
    margin: "8px 0",
  },
  loadingMessage: {
    display: "flex",
    alignItems: "center",
  },
  loadingDot: {
    width: "8px",
    height: "8px",
    backgroundColor: "#4a6cf7",
    borderRadius: "50%",
    margin: "0 2px",
    opacity: 0.6,
  },
  inputContainer: {
    marginTop: "20px",
    display: "flex",
    position: "relative" as const,
  },
  textarea: {
    flexGrow: 1,
    padding: "16px 60px 16px 18px",
    borderRadius: "24px",
    border: "1px solid #dee2e6",
    fontSize: "0.95rem",
    resize: "none" as const,
    outline: "none",
    transition: "all 0.2s ease",
    minHeight: "56px",
    maxHeight: "160px",
    lineHeight: "1.5",
    boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
  },
  sendButton: {
    position: "absolute" as const,
    right: "10px",
    bottom: "10px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#4a6cf7",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(74,108,247,0.25)",
    fontSize: "18px",
  },
  sendButtonDisabled: {
    backgroundColor: "#adb5bd",
    boxShadow: "none",
    cursor: "not-allowed",
  },
  error: {
    backgroundColor: "#fff5f5",
    color: "#e03131",
    padding: "12px 16px",
    borderRadius: "8px",
    marginTop: "16px",
    fontSize: "0.9rem",
    textAlign: "left" as const,
    boxShadow: "0 2px 8px rgba(224,49,49,0.1)",
    display: "flex",
    alignItems: "flex-start",
    border: "1px solid #ffe3e3",
  },
  errorIcon: {
    marginRight: "10px",
    fontSize: "16px",
    marginTop: "1px",
  },
  hint: {
    marginTop: "16px",
    fontSize: "0.85rem",
    color: "#6c757d",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  hintIcon: {
    marginRight: "6px",
    fontSize: "14px",
  },
  typingIndicator: {
    display: "flex",
    padding: "0 16px",
  },
  typingDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#6c757d",
    margin: "0 1px",
    opacity: 0.6,
  },
  poweredBy: {
    fontSize: "0.8rem",
    color: "#adb5bd",
    marginTop: "16px",
    textAlign: "center" as const,
  },
  agentInfo: {
    padding: "12px 16px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    marginBottom: "16px",
    fontSize: "0.9rem",
    color: "#495057",
    display: "flex",
    alignItems: "center",
    border: "1px solid #e9ecef",
  },
  agentInfoIcon: {
    marginRight: "10px",
    fontSize: "16px",
    color: "#4a6cf7",
  },
  clearButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#6c757d",
    fontSize: "0.85rem",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    marginLeft: "16px",
  },
  clearIcon: {
    marginRight: "4px",
    fontSize: "12px",
  },
};